import { v4 } from 'uuid';

import {
  errorHandling,
  logConfig,
  logFiltering,
  popupErrors,
  popupErrorsFilter,
} from '../../configDebug';
import LibraryConfig from '../../configLib';

import { patchConsole } from './LogFiltering';

// ===========   DEVELOP Settings   ===========
if (LibraryConfig?.__DEV__) {
  if (!popupErrors) LibraryConfig?.disablePopups(true);
  if (popupErrorsFilter != null) LibraryConfig?.disablePopupsFilter(popupErrorsFilter);
  if (logFiltering) patchConsole();
  if (errorHandling) LibraryConfig?.errorHandlingInit();
}


// ===========   RELEASE Settings   ===========

export function noop(...args: any[]) {}

if (!LibraryConfig?.__DEV__ || !logConfig?.enabled) {
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
  console.error = noop;
  console.time = noop;
  console.timeEnd = noop;
}
if (!console.time) {
  console.time = () => {};
  console.timeEnd = () => {};
}


if (typeof LibraryConfig?.getRandomValuesInit === 'function') {
  LibraryConfig.getRandomValuesInit();
}
export const uuidv4 = v4;
